/**
 * Component overrides get their own file per component (matching the
 * reference's `theme/Button/index.tsx` pattern) and are merged here. The
 * rest of `theme/components/*.ts` named in the migration plan get added when
 * the wave that actually needs them (Dialog, Table, …) is underway, not
 * stubbed out empty ahead of time.
 */
import type { Components, Theme } from '@mui/material/styles';
/* Side-effect import: merges `MuiDateCalendar`/`MuiPickersDay`/etc. into
   `Components<Theme>` — without it those keys don't exist on the type at
   all, since `@mui/x-date-pickers` augments MUI's base theme types rather
   than exporting its own. */
import '@mui/x-date-pickers/themeAugmentation';
import { MuiAutocomplete } from './MuiAutocomplete';
import { MuiButton } from './MuiButton';
import {
	MuiBadge,
	MuiChip,
	MuiTablePagination,
	MuiToggleButton,
	MuiTooltip,
} from './fixedSizes';
import {
	MuiDateCalendar,
	MuiDayCalendar,
	MuiPickersCalendarHeader,
	MuiPickersDay,
} from './MuiDateCalendar';
import { MuiLinearProgress } from './MuiLinearProgress';
import { MuiListItemButton } from './MuiListItemButton';
import { MuiOutlinedInput } from './MuiOutlinedInput';
import { MuiTab } from './MuiTab';
import { MuiTable } from './MuiTable';
import { MuiTableCell } from './MuiTableCell';
import { MuiTableRow } from './MuiTableRow';
import { MuiTableSortLabel } from './MuiTableSortLabel';

export const components: Components<Theme> = {
	MuiBadge,
	MuiChip,
	MuiTablePagination,
	MuiToggleButton,
	MuiTooltip,
	MuiButton,
	MuiAutocomplete,
	MuiLinearProgress,
	MuiListItemButton,
	MuiOutlinedInput,
	MuiTab,
	MuiTable,
	MuiTableCell,
	MuiTableRow,
	MuiTableSortLabel,
	MuiDateCalendar,
	MuiPickersDay,
	MuiDayCalendar,
	MuiPickersCalendarHeader,
};
